import { useForm } from "react-final-form";

import { Heading, MessageBar, MessageBarType, Stack } from "@bps/fluent-ui";
import { AddressType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { Contact } from "@stores/practice/models/Contact.ts";

import { AddressTypeCheckboxFields } from "../../../shared-components/AddressTypeCheckboxFields.tsx";
import { Labels } from "../../../shared-components/types/labels.enums.types.ts";
import { OrganisationCardIds } from "../../../shared-components/types/organisation-card-ids.enum.ts";
import { AddContactMethodsButton } from "../../shared-components/edit/contact-methods/AddContactMethodsButton.tsx";
import { ContactMethodAddress } from "../../shared-components/edit/contact-methods/ContactMethodAddress.tsx";
import { ContactMethodCommunications } from "../../shared-components/edit/contact-methods/ContactMethodCommunications.tsx";
import { OrganisationLabels } from "../organisation.types.ts";
import {
  EditOrganisationFormValues,
  orgEditFormNameOf
} from "./EditOrganisationFormValues.tsx";

interface EditOrganisationalLocationProps {
  organisation: Contact | undefined;
}

export const EditOrganisationalLocation = ({
  organisation
}: EditOrganisationalLocationProps) => {
  const form = useForm<EditOrganisationFormValues>();
  const { values } = useForm<EditOrganisationFormValues>().getState();

  const locationIsRequired =
    values.privateInsurer?.accPrivateInsurer ||
    values.employer?.accreditedEmployer;

  return (
    <div
      id={`${OrganisationCardIds.OrganisationLocation}-edit`}
      style={{ paddingRight: 16 }}
    >
      <Stack
        styles={(_props, theme) => {
          return {
            root: {
              borderBottom: "1px solid",
              borderColor: theme.palette.neutralLighterAlt
            }
          };
        }}
      >
        <Stack
          horizontal
          horizontalAlign="space-between"
          styles={{ root: { lineHeight: "22px", marginBottom: 8 } }}
        >
          <Heading
            variant="section-heading-light"
            styles={{ root: { padding: "5px 0" } }}
          >
            {Labels.location}
          </Heading>
          <AddContactMethodsButton reactFinalForm={form} formValues={values} />
        </Stack>
        <Stack tokens={{ childrenGap: 16 }}>
          {locationIsRequired && (
            <MessageBar
              styles={{
                root: {
                  marginTop: 16
                }
              }}
              messageBarType={MessageBarType.warning}
            >
              {OrganisationLabels.AddressDetailsRequired}
            </MessageBar>
          )}
          <ContactMethodAddress
            name={orgEditFormNameOf("addresses")}
            defaultAddressType={AddressType.Both}
            onRenderFieldsetActions={(parentName, index) => (
              <AddressTypeCheckboxFields
                parentName={parentName}
                index={index}
              />
            )}
          />
          <ContactMethodCommunications
            contact={organisation}
            disablePreferredChoice
            disableSendForm
            noDefaultCommunication={true}
            name={orgEditFormNameOf("communications")}
          />
        </Stack>
      </Stack>
    </div>
  );
};
